<app-header></app-header>

<div class="min-h-screen pb-10 tema-claro">
  <div class="max-w-7xl mx-auto p-6">

    <!-- Breadcrumb -->
    <div class="mb-4 flex items-center gap-2 text-xs" style="color: var(--tx-2)">
      <a routerLink="/home" class="hover:underline" style="color: var(--brand-primary)">Início</a>
      <span>/</span>
      <span class="font-semibold" style="color: var(--tx)">Gerenciar Fila</span>
    </div>

    <!-- ════════════════════════════════════ HEADER + CONFIGURAR ══ -->
    <div class="mb-5 flex items-start justify-between gap-4 flex-wrap">
      <div>
        <h1 class="text-2xl font-semibold" style="color: var(--tx)">Gerenciar Fila</h1>
        <p class="text-sm mt-1" style="color: var(--tx-2)">Visão gerencial — tempo real via SignalR. Cada paciente aparece em um único grupo.</p>
      </div>
      <div class="flex items-center gap-3">
        <div *ngIf="isLoading" class="flex items-center gap-1.5 text-sm" style="color: var(--brand-primary)">
          <svg class="animate-spin w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
          </svg>
          Carregando...
        </div>

        <!-- Toggle chamada automática -->
        <button
          type="button"
          (click)="toggleAutoCall()"
          [disabled]="savingAutoCall"
          class="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition"
          [ngStyle]="{
            'background-color': autoCallEnabled ? '#dcfce7' : '#fee2e2',
            'color':            autoCallEnabled ? '#166534' : '#991b1b',
            'border':           autoCallEnabled ? '1px solid #86efac' : '1px solid #fca5a5',
            'opacity':          savingAutoCall ? '0.6' : '1'
          }"
          [title]="autoCallEnabled ? 'Chamada automática ATIVADA — clique para desativar' : 'Chamada automática DESATIVADA — clique para ativar'"
        >
          <svg *ngIf="savingAutoCall" class="animate-spin w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
          </svg>
          <svg *ngIf="!savingAutoCall" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
          Auto-chamada {{ autoCallEnabled ? 'ON' : 'OFF' }}
        </button>
        <span *ngIf="autoCallError" class="text-xs" style="color: #991b1b">Falha ao salvar. Tente novamente.</span>

        <button
          type="button"
          (click)="showConfig = !showConfig"
          class="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition"
          [ngStyle]="{ 'background-color': showConfig ? 'var(--brand-primary)' : 'var(--brand-tint)', 'color': showConfig ? '#ffffff' : 'var(--brand-primary)' }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"/>
          </svg>
          Configurar Ordem
        </button>
      </div>
    </div>

    <!-- ════════════════════════════════════ PAINEL DE CONFIGURAÇÃO ══ -->
    <div *ngIf="showConfig" class="mb-5 rounded-2xl shadow-sm overflow-hidden" style="border: 1px solid var(--flua-borda)">
      <div class="px-5 py-3 flex items-center justify-between" style="background-color: var(--thead)">
        <div class="flex items-center gap-2 text-white font-semibold text-sm">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"/>
          </svg>
          Ordem e Pesos dos Grupos
        </div>
        <button type="button" (click)="resetOrder()" class="text-xs text-white opacity-80 hover:opacity-100 underline">
          Restaurar padrão
        </button>
      </div>
      <div class="bg-white px-5 py-4">
        <p class="text-xs mb-1" style="color: var(--tx-2)">
          Cada grupo tem um <strong>peso editável</strong>. Um paciente pode se encaixar em vários grupos — o
          <strong>score</strong> é a soma dos pesos de todos os grupos que ele qualifica.
          Quem tem maior score é atendido primeiro dentro do seu grupo.
        </p>
        <p class="text-xs mb-4 px-3 py-2 rounded-lg" style="background-color: #f0f9ff; color: #0c4a6e; border: 1px solid #bae6fd">
          Exemplo: Idoso 80+ + Médico Ocioso →
          <strong>{{ groupWeight('prioridade80') }} + {{ groupWeight('medicoOcioso') }} = {{ groupWeight('prioridade80') + groupWeight('medicoOcioso') }}</strong> pontos
        </p>
        <div class="flex flex-col gap-2">
          <div *ngFor="let key of groupOrder; let i = index"
               class="flex items-center gap-3 px-3 py-2.5 rounded-lg"
               style="border: 1px solid var(--flua-borda); background-color: #fafafa">
            <!-- Posição -->
            <span class="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-white flex-shrink-0"
                  [ngStyle]="{ 'background-color': grupoConfig(key).cor }">
              {{ i + 1 }}
            </span>
            <!-- Info -->
            <div class="flex-1 min-w-0">
              <p class="text-sm font-semibold" style="color: var(--tx)">{{ grupoConfig(key).label }}</p>
              <p class="text-xs" style="color: var(--tx-3)">{{ grupoConfig(key).descricao }}</p>
            </div>
            <!-- Peso editável -->
            <div class="flex items-center gap-1.5 flex-shrink-0">
              <span class="text-[10px] font-semibold uppercase tracking-wide" style="color: var(--tx-3)">Peso</span>
              <input type="number" min="1" max="99"
                     [value]="groupWeight(key)"
                     (change)="setWeight(key, $event)"
                     class="w-14 text-center text-xs font-bold rounded-lg px-1.5 py-1 transition focus:outline-none focus:ring-2"
                     style="border: 1px solid var(--flua-borda); background-color: var(--flua-rodape); color: var(--brand-primary); focus-ring-color: var(--brand-primary)" />
            </div>
            <!-- Controles -->
            <div class="flex items-center gap-1 flex-shrink-0">
              <button type="button" (click)="moveUp(i)" [disabled]="i === 0"
                      class="w-7 h-7 rounded flex items-center justify-center transition"
                      [ngClass]="i === 0 ? 'opacity-30 cursor-not-allowed bg-gray-100' : 'hover:bg-purple-100 bg-gray-100'">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3.5 h-3.5" style="color: var(--brand-primary)">
                  <path fill-rule="evenodd" d="M10 17a.75.75 0 0 1-.75-.75V5.612L5.29 9.77a.75.75 0 0 1-1.08-1.04l5.25-5.5a.75.75 0 0 1 1.08 0l5.25 5.5a.75.75 0 1 1-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0 1 10 17Z" clip-rule="evenodd"/>
                </svg>
              </button>
              <button type="button" (click)="moveDown(i)" [disabled]="i === groupOrder.length - 1"
                      class="w-7 h-7 rounded flex items-center justify-center transition"
                      [ngClass]="i === groupOrder.length - 1 ? 'opacity-30 cursor-not-allowed bg-gray-100' : 'hover:bg-purple-100 bg-gray-100'">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3.5 h-3.5" style="color: var(--brand-primary)">
                  <path fill-rule="evenodd" d="M10 3a.75.75 0 0 1 .75.75v10.638l3.96-4.158a.75.75 0 1 1 1.08 1.04l-5.25 5.5a.75.75 0 0 1-1.08 0l-5.25-5.5a.75.75 0 1 1 1.08-1.04l3.96 4.158V3.75A.75.75 0 0 1 10 3Z" clip-rule="evenodd"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ════════════════════════════════════ EXPLICAÇÃO DO SCORE ══ -->
    <div class="mb-5 bg-white rounded-2xl shadow-sm px-5 py-4" style="border: 1px solid var(--flua-borda)">
      <div class="flex items-center gap-2 mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="var(--brand-primary)" class="w-4 h-4 flex-shrink-0">
          <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"/>
        </svg>
        <span class="text-sm font-semibold" style="color: var(--tx)">Como funciona a prioridade</span>
      </div>
      <p class="text-xs mb-3" style="color: var(--tx-2)">
        Cada grupo tem um <strong>peso</strong> (editável em "Configurar Ordem").
        O <strong>score</strong> de um paciente é a soma dos pesos de <em>todos</em> os grupos que ele qualifica — pacientes com score maior
        são chamados primeiro dentro do seu grupo. A <strong>previsão</strong> estima o tempo de espera com base em quantos
        pacientes têm score maior × tempo médio de atendimento ({{ AVG_SERVICE_MIN }} min).
      </p>
      <div class="flex flex-wrap gap-2">
        <div *ngFor="let key of groupOrder; let i = index"
             class="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium"
             [ngStyle]="{ 'background-color': grupoConfig(key).corBg, 'color': grupoConfig(key).corText, 'border': '1px solid ' + grupoConfig(key).corBorder }">
          <span class="w-4 h-4 rounded-full flex items-center justify-center text-[9px] font-bold text-white flex-shrink-0"
                [ngStyle]="{ 'background-color': grupoConfig(key).cor }">{{ i + 1 }}</span>
          {{ grupoConfig(key).label }}
          <span class="font-bold ml-0.5">P{{ groupWeight(key) }}</span>
        </div>
      </div>
    </div>

    <!-- ════════════════════════════════════ MÉTRICAS + GRÁFICO ══ -->
    <div class="mb-5 grid grid-cols-2 md:grid-cols-4 gap-3">
      <!-- Card Total -->
      <div class="bg-white rounded-2xl px-4 py-3 shadow-sm flex items-center gap-3" style="border: 1px solid var(--flua-borda)">
        <div class="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style="background-color: var(--brand-tint)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="var(--brand-primary)" class="w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>
          </svg>
        </div>
        <div>
          <p class="text-2xl font-bold" style="color: var(--tx)">{{ totalAtivos }}</p>
          <p class="text-xs" style="color: var(--tx-3)">Total na fila</p>
        </div>
      </div>
      <!-- Card Aguardando -->
      <div class="bg-white rounded-2xl px-4 py-3 shadow-sm flex items-center gap-3" style="border: 1px solid var(--flua-borda)">
        <div class="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style="background-color: #ecfdf5">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#22c55e" class="w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
        </div>
        <div>
          <p class="text-2xl font-bold" style="color: var(--tx)">{{ totalAguardando }}</p>
          <p class="text-xs" style="color: var(--tx-3)">Aguardando</p>
        </div>
      </div>
      <!-- Card Média -->
      <div class="bg-white rounded-2xl px-4 py-3 shadow-sm flex items-center gap-3" style="border: 1px solid var(--flua-borda)">
        <div class="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style="background-color: #eff6ff">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#3b82f6" class="w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"/>
          </svg>
        </div>
        <div>
          <p class="text-2xl font-bold" style="color: var(--tx)">{{ mediaTempEsperaMin }}<span class="text-sm font-normal ml-0.5">min</span></p>
          <p class="text-xs" style="color: var(--tx-3)">Espera média atual</p>
        </div>
      </div>
      <!-- Card Maior espera -->
      <div class="bg-white rounded-2xl px-4 py-3 shadow-sm flex items-center gap-3"
           [ngStyle]="{ 'border': '1px solid ' + (maiorEsperaMin > 30 ? '#fecaca' : '#E5DFD4'), 'background-color': maiorEsperaMin > 30 ? '#fff8f8' : 'white' }">
        <div class="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
             [ngStyle]="{ 'background-color': maiorEsperaMin > 30 ? '#fee2e2' : '#fef3c7' }">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
               [attr.stroke]="maiorEsperaMin > 30 ? '#ef4444' : '#f59e0b'" class="w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
          </svg>
        </div>
        <div>
          <p class="text-2xl font-bold" [ngStyle]="{ 'color': maiorEsperaMin > 30 ? '#ef4444' : '#0B2C45' }">
            {{ maiorEsperaMin }}<span class="text-sm font-normal ml-0.5">min</span>
          </p>
          <p class="text-xs" style="color: var(--tx-3)">Maior espera</p>
        </div>
      </div>
    </div>

    <!-- Análise por grupo -->
    <div class="bg-white rounded-2xl shadow-sm mb-5 overflow-hidden" style="border: 1px solid var(--flua-borda)">
      <div class="px-5 py-3 flex items-center gap-2" style="border-bottom: 1px solid var(--flua-borda)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="var(--brand-primary)" class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"/>
        </svg>
        <span class="text-sm font-semibold" style="color: var(--tx)">Análise por grupo</span>
      </div>

      <div *ngIf="totalAtivos === 0" class="px-5 py-4 text-sm text-center" style="color: var(--tx-3)">
        Nenhum paciente na fila no momento.
      </div>

      <div *ngIf="totalAtivos > 0" class="overflow-x-auto">
        <!-- Cabeçalho -->
        <div class="grid px-5 py-2 text-[10px] font-bold uppercase tracking-wide"
             style="grid-template-columns: 180px 60px 1fr 80px 100px; color: var(--tx-3); border-bottom: 1px solid #F4F1EA">
          <span>Grupo</span>
          <span class="text-center">Peso</span>
          <span class="pl-2">Distribuição</span>
          <span class="text-right">Pacientes</span>
          <span class="text-right">Previsão</span>
        </div>
        <!-- Linhas -->
        <div *ngFor="let g of grupos; let last = last"
             class="grid items-center px-5 py-3"
             style="grid-template-columns: 180px 60px 1fr 80px 100px"
             [ngStyle]="{ 'border-bottom': last ? 'none' : '1px solid #F4F1EA' }">
          <!-- Grupo -->
          <div class="flex items-center gap-2 min-w-0">
            <span class="w-2.5 h-2.5 rounded-full flex-shrink-0" [ngStyle]="{ 'background-color': g.cor }"></span>
            <span class="text-xs font-medium truncate" style="color: var(--tx)">{{ g.label }}</span>
          </div>
          <!-- Peso -->
          <div class="text-center">
            <span class="text-xs font-bold px-2 py-0.5 rounded-full"
                  [ngStyle]="{ 'background-color': g.corBg, 'color': g.corText, 'border': '1px solid ' + g.corBorder }">
              {{ groupWeight(g.key) }}
            </span>
          </div>
          <!-- Barra -->
          <div class="px-2">
            <div class="bg-gray-100 rounded-full h-3.5 overflow-hidden">
              <div class="h-3.5 rounded-full transition-all duration-500"
                   [ngStyle]="{ 'width': barWidthPct(g.key) + '%', 'background-color': g.cor, 'min-width': countGrupo(g.key) > 0 ? '1.5rem' : '0' }">
              </div>
            </div>
          </div>
          <!-- Pacientes -->
          <div class="text-right">
            <span class="text-sm font-bold" style="color: var(--tx)">{{ countGrupo(g.key) }}</span>
            <span class="text-xs ml-1" style="color: var(--tx-3)">{{ barWidthPct(g.key) > 0 ? '(' + barWidthPct(g.key) + '%)' : '' }}</span>
          </div>
          <!-- Previsão -->
          <div class="text-right">
            <ng-container *ngIf="countGrupo(g.key) > 0; else semPacientes">
              <span *ngIf="estimatedWaitMin(g.key) === 0"
                    class="text-xs font-semibold px-2 py-0.5 rounded-full"
                    style="background-color: #dcfce7; color: #166534">
                próximo agora
              </span>
              <span *ngIf="estimatedWaitMin(g.key) > 0"
                    class="text-xs font-semibold px-2 py-0.5 rounded-full"
                    [ngStyle]="{
                      'background-color': estimatedWaitMin(g.key) <= 15 ? '#dcfce7' : estimatedWaitMin(g.key) <= 30 ? '#fef3c7' : '#fee2e2',
                      'color': estimatedWaitMin(g.key) <= 15 ? '#166534' : estimatedWaitMin(g.key) <= 30 ? '#92400e' : '#991b1b'
                    }">
                ~{{ estimatedWaitMin(g.key) }} min
              </span>
            </ng-container>
            <ng-template #semPacientes>
              <span class="text-xs" style="color: #D6CFC2">—</span>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <!-- ════════════════════════════════════ GRUPOS (ordem configurável) ══ -->
    <div class="flex flex-col gap-4">
      <ng-container *ngFor="let g of grupos">
        <div class="rounded-2xl shadow-sm overflow-hidden"
             [ngStyle]="{ 'border': '1px solid ' + g.corBorder }">

          <!-- Header do grupo -->
          <button type="button"
                  class="w-full flex items-center justify-between px-5 py-3 text-left"
                  [ngStyle]="{ 'background-color': g.corBg }"
                  (click)="toggleSection(g.key)">
            <div class="flex items-center gap-2 flex-wrap">
              <div class="w-3 h-3 rounded-full flex-shrink-0" [ngStyle]="{ 'background-color': g.cor }"></div>
              <span class="font-semibold text-sm" [ngStyle]="{ 'color': g.corText }">{{ g.label }}</span>
              <!-- Qtd pacientes -->
              <span class="px-2 py-0.5 rounded-full text-xs font-bold"
                    [ngStyle]="{ 'background-color': g.corBg, 'color': g.corText, 'border': '1px solid ' + g.corBorder }">
                {{ countGrupo(g.key) }}
              </span>
              <!-- Previsão de atendimento -->
              <span *ngIf="countGrupo(g.key) > 0" class="text-[10px] hidden md:inline px-2 py-0.5 rounded-full"
                    style="background-color: var(--flua-fundo); color: var(--tx-3)">
                próximo ~{{ estimatedWaitMin(g.key) }}min
              </span>
              <span class="text-xs hidden lg:block" style="color: var(--tx-3)">— {{ g.descricao }}</span>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                 class="w-4 h-4 flex-shrink-0 transition-transform"
                 [ngStyle]="{ 'color': g.cor }"
                 [class.rotate-180]="openSections[g.key]">
              <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
            </svg>
          </button>

          <!-- Tabela do grupo -->
          <div *ngIf="openSections[g.key]" class="bg-white overflow-x-auto">
            <div *ngIf="countGrupo(g.key) === 0" class="px-5 py-4 text-sm" style="color: var(--tx-3)">
              Nenhum paciente neste grupo.
            </div>
            <table *ngIf="countGrupo(g.key) > 0" class="w-full text-xs">
              <thead>
                <tr class="text-left" [ngStyle]="{ 'background-color': g.corBg, 'border-bottom': '1px solid ' + g.corBorder }">
                  <th class="px-4 py-2 font-semibold" [ngStyle]="{ 'color': g.corText }">Grupos</th>
                  <th class="px-4 py-2 font-semibold w-20" [ngStyle]="{ 'color': g.corText }">Senha</th>
                  <th class="px-4 py-2 font-semibold" [ngStyle]="{ 'color': g.corText }">Paciente</th>
                  <th class="px-4 py-2 font-semibold" [ngStyle]="{ 'color': g.corText }">Médico</th>
                  <th class="px-4 py-2 font-semibold" [ngStyle]="{ 'color': g.corText }">Especialidade</th>
                  <th class="px-4 py-2 font-semibold" [ngStyle]="{ 'color': g.corText }">Agendamento</th>
                  <th class="px-4 py-2 font-semibold" *ngIf="g.key === 'atrasados'" [ngStyle]="{ 'color': g.corText }">Atraso</th>
                  <th class="px-4 py-2 font-semibold" [ngStyle]="{ 'color': g.corText }">Aguardando</th>
                  <th class="px-4 py-2 font-semibold" [ngStyle]="{ 'color': g.corText }">Guichê</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let p of getGrupo(g.key)">
                  <tr class="border-b transition-colors"
                      [ngStyle]="{ 'border-color': g.corBorder }"
                      [ngClass]="estourou(p) ? 'bg-red-50 hover:bg-red-100' : 'hover:bg-gray-50'">
                    <!-- Grupos qualificados (sem pontos) -->
                    <td class="px-4 py-2">
                      <div class="flex flex-wrap gap-1 min-w-[100px]">
                        <span *ngFor="let item of getQualifyingGroups(p)"
                              class="text-[9px] font-bold px-1.5 py-0.5 rounded-full whitespace-nowrap"
                              [ngStyle]="{ 'background-color': item.config.corBg, 'color': item.config.corText, 'border': '1px solid ' + item.config.corBorder }">
                          {{ item.config.label }}<span *ngIf="item.fator > 1" class="ml-0.5 font-extrabold">×{{ item.fator }}</span>
                        </span>
                        <span *ngIf="getQualifyingGroups(p).length === 0" class="text-xs" style="color: #D6CFC2">—</span>
                      </div>
                    </td>
                    <td class="px-4 py-2">
                      <span class="font-bold" style="color: var(--brand-primary)">{{ p.dsPassword }}</span>
                    </td>
                    <td class="px-4 py-2">
                      <div class="flex items-center gap-1.5">
                        <span *ngIf="p.priority" class="px-1.5 py-0.5 rounded text-[9px] font-bold bg-amber-100 text-amber-700 flex-shrink-0">PRIOR.</span>
                        <span class="font-medium" style="color: var(--tx)">{{ shortName(nomeExibicao(p)) | titlecase }}</span>
                      </div>
                    </td>
                    <td class="px-4 py-2" style="color: var(--tx-2)">
                      <span *ngIf="p.agendaHoje; else semMedico" class="truncate block max-w-[160px]" [title]="p.agendaHoje">{{ p.agendaHoje }}</span>
                      <ng-template #semMedico><span style="color: #D6CFC2">—</span></ng-template>
                    </td>
                    <td class="px-4 py-2" style="color: var(--tx-2)">{{ p.specialty }}</td>
                    <td class="px-4 py-2 font-medium" style="color: var(--brand-primary)">{{ scheduledLabel(p) }}</td>
                    <td *ngIf="g.key === 'atrasados'" class="px-4 py-2 font-semibold text-orange-600">{{ atrasoLabel(p) }}</td>
                    <td class="px-4 py-2">
                      <span class="font-semibold"
                            [class.text-green-600]="delayColor(p) === 'green'"
                            [class.text-yellow-600]="delayColor(p) === 'yellow'"
                            [class.text-red-600]="delayColor(p) === 'red'">
                        {{ elapsedTimes[p.id] }}
                      </span>
                    </td>
                    <td class="px-4 py-2" style="color: var(--tx-2)">{{ p.calledMachine || '—' }}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

        </div>
      </ng-container>
    </div>

  </div>
</div>
